import React, { createContext, ReactNode, useContext } from 'react';
import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import { TrackingDescriptorType } from '../Tracking/types';
import { ProductCardProps } from '../ProductCard/types';

export type ProductActionsContext = {
  onAddToCart?: (
    event: React.SyntheticEvent,
    hit: AlgoliaProductHit,
    variantId?: number,
    trackingDescriptor?: TrackingDescriptorType,
    source?: string
  ) => Promise<boolean>;
  productCartPropsOverrides?: Partial<ProductCardProps>;
};

export const ProductActionsContext = createContext<ProductActionsContext>({});

export const ProductActionsProvider = ({ children, ...values }: ProductActionsContext & { children: ReactNode }) => {
  return <ProductActionsContext.Provider value={{ ...values }}>{children}</ProductActionsContext.Provider>;
};

export const useProductActionsContext = (): ProductActionsContext => {
  return useContext(ProductActionsContext);
};
